<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.question-circle-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Frequently asked questions') }}
          </h1>
        </div>
        <div class="flex md:mt-0 md:ml-4">
          <router-link class="btn btn-purple rounded-none rounded-l-md" to="/admin/faq/new"> {{ $t('New FAQ') }}</router-link>
          <button @click.prevent="$router.back()" type="button" class="btn btn-purple rounded-none rounded-r-md">
            {{ $t('Back') }}
          </button>
        </div>
      </div>
    </div>

    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <template v-if="faqList.length > 0">
          <ul>
            <template v-for="(faq, index) in faqList">
              <li :class="{ 'border-t border-gray-200': index !== 0 }" :key="index">
                <router-link
                  :to="`/admin/faq/${faq.id}/edit`"
                  class="
                    block
                    hover:bg-gray-100
                    focus:outline-none
                    focus:bg-gray-100
                    transition
                    duration-150
                    ease-in-out
                  "
                >
                  <div class="flex items-center px-4 py-4 sm:px-6">
                    <div class="min-w-0 flex-1 flex items-center">
                      <div
                        class="
                          min-w-0
                          flex-1
                          pr-4
                          lg:grid lg:grid-cols-2
                          lg:gap-4
                        "
                      >
                        <div class="flex">
                          <div
                            class="
                              inline-block
                              align-middle
                              text-sm
                              font-medium
                              leading-5
                              text-gray-900
                            "
                          >
                            {{ faq.question }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <svg-vue class="h-5 w-5 text-gray-400" icon="font-awesome.angle-right-regular"></svg-vue>
                    </div>
                  </div>
                </router-link>
              </li>
            </template>
          </ul>
        </template>
        <template v-else="!loading">
          <div class="h-full flex">
            <div class="m-auto">
              <div
                class="
                  grid grid-cols-1
                  justify-items-center
                  h-full
                  w-full
                  px-4
                  py-10
                "
              >
                <div class="flex justify-center items-center">
                  <svg-vue class="h-full h-auto w-64 mb-12" icon="undraw.browsing"></svg-vue>
                </div>
                <div class="flex justify-center items-center">
                  <div class="w-full font-semibold text-2xl">
                    {{ $t('No records found') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'list',
  metaInfo() {
    return {
      title: this.$i18n.t('FAQ'),
    };
  },
  data() {
    return {
      loading: true,
      faqList: [],
    };
  },
  mounted() {
    this.getFaqs();
  },
  methods: {
    getFaqs() {
      this.loading = true;
      axios
        .get(route('faq.index'))
        .then((response) => {
          this.faqList = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
